import { cn } from '@/lib/format';

type Props = {
  children: React.ReactNode;
  className?: string;
  as?: React.ElementType;
};

export function Container({ children, className, as: As = 'div' }: Props) {
  return <As className={cn('container-x', className)}>{children}</As>;
}
